import { createApiRequest } from "@/lib/api/createApiService";
import { AUTH_ENDPOINTS } from "./auth.endpoints";

export const authService = {
  login: async (payload, options = {}) => {
    return createApiRequest({
      url: options?.url ?? AUTH_ENDPOINTS.LOGIN,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  register: async (payload, options = {}) => {
    return createApiRequest({
      url: AUTH_ENDPOINTS.REGISTER,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  logout: async (options = {}) => {
    return createApiRequest({
      url: AUTH_ENDPOINTS.LOGOUT,
      method: "POST",
      body: {},
      ...options,
    });
  },

  refresh: async (options = {}) => {
    return createApiRequest({
      url: AUTH_ENDPOINTS.REFRESH,
      method: "POST",
      body: {},
      ...options,
    });
  },

  getMe: async (options = {}) => {
    return createApiRequest({
      url: AUTH_ENDPOINTS.ME,
      method: "GET",
      ...options,
    });
  },

  requestPasswordReset: async (payload, options = {}) => {
    return createApiRequest({
      url: AUTH_ENDPOINTS.REQUEST_FORGOT_PASSWORD,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  send2FACode: async (payload, options = {}) => {
    return createApiRequest({
      url: AUTH_ENDPOINTS.SEND_2FA_CODE,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  verify2FAOtp: async (payload, options = {}) => {
    return createApiRequest({
      url: AUTH_ENDPOINTS.VERIFY_2FA_OTP,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  verifyOtp: async (payload, options = {}) => {
    return createApiRequest({
      url: AUTH_ENDPOINTS.CONFIRM_OTP,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  confirmResetToken: async (payload, options = {}) => {
    return createApiRequest({
      url: AUTH_ENDPOINTS.CONFIRM_RESET_TOKEN,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  updatePassword: async (payload, options = {}) => {
    return createApiRequest({
      url: AUTH_ENDPOINTS.UPDATE_PASSWORD,
      method: "POST",
      body: payload,
      ...options,
    });
  },
};
